module.exports = __webpack_public_path__ + "img/badges.3df87627.png";